function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ROLES_LIST } from '@/js/constants';
import { mapState } from 'vuex';
export var userMixin = {
  data: function data() {
    return {
      userDomain: window.userInfo.domain,
      userEmail: window.userInfo.email,
      userPhotoURL: window.userInfo.photoURL,
      rolesINCA: ROLES_LIST
    };
  },
  methods: {
    getUserInitials: function getUserInitials() {
      return this.userEmail.toUpperCase().substr(0, 2);
    },
    setLocale: function setLocale(locale) {
      this.$i18n.locale = locale;
      this.$vuetify.lang.current = locale;

      // example on how certain languages can be RTL
      if (locale === 'ar') {
        this.$vuetify.rtl = true;
      } else {
        this.$vuetify.rtl = false;
      }
    },
    translate: function translate(key) {
      return this.$i18n.t(key);
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['defaultLanguage'])), {}, {
    userHasRole: function userHasRole() {
      var _this = this;
      return function (role) {
        return _this.userInfo.userRoles.indexOf(role) !== -1;
      };
    },
    userInfo: {
      get: function get() {
        return window.userInfo;
      },
      set: function set(newUserInfo) {
        window.userInfo = newUserInfo;
      }
    }
  })
};